<template>
  <div
    class="NavigationButton__Container"
    @click="$emit('clicked')"
  >
    <div
      :class="
        ['NavigationButton__Button',
         selected
           ?
             'NavigationButton__Button_Selected'
           :
             '']"
    >
      <div
        v-if="icon === 'home'"
        :class="['NavigationButton__Icon', 'NavigationButton__Icon_Home', selected ? 'NavigationButton__Icon_Selected': '']"
      />
      <div
        v-if="icon === 'shape'"
        :class="['NavigationButton__Icon', 'NavigationButton__Icon_Shape', selected ? 'NavigationButton__Icon_Selected': '']"
      />
      <div
        v-if="icon === 'texture'"
        :class="['NavigationButton__Icon', 'NavigationButton__Icon_Texture', selected ? 'NavigationButton__Icon_Selected': '']"
      />
      <div
        v-if="icon === 'save'"
        :class="['NavigationButton__Icon', 'NavigationButton__Icon_Save', selected ? 'NavigationButton__Icon_Selected': '']"
      />
    </div>
    <div class="NavigationButton__TextDiv">
      <p :class="['NavigationButton__Text', selected ? 'NavigationButton__TextSelected' : '']">
        {{ name }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selected: { type: Boolean, default: false },
    name: { type: String, default: '' },
    icon: { type: String, default: '' }
  }
}
</script>

<style scoped>
.NavigationButton__Container{
}

@media screen and (min-width: 1200px) {
  .NavigationButton__Button{
      width: 50px;
      height: 50px;
      border-radius: 100%;
      border: 1px grey solid;
      box-sizing: border-box;
      display: flex;
  }
}

@media screen and (max-width: 1200px) {
  .NavigationButton__Button{
      width: 45px;
      height: 45px;
      border-radius: 100%;
      border: 1px grey solid;
      box-sizing: border-box;
      display: flex;
  }
}

.NavigationButton__Button_Selected{
    background: black;
    border: 1px black solid;
}

.NavigationButton__TextDiv{
    display: flex;
    justify-content: center;
    margin-right: -0.4em;
}

.NavigationButton__Text{
    position:absolute;
    margin-top: 10px;
    text-align: center;
    font-size: 0.6em;
    letter-spacing: 0.4em;
    font-weight: 300;
}

.NavigationButton__TextSelected {
    font-weight: 600;
}

.NavigationButton__Icon {
  width: 70%;
  height: 70%;
  margin: auto;
  background: black;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}

.NavigationButton__Icon_Selected {
  background: white;
}

.NavigationButton__Icon_Home {
  width: 60%;
  height: 60%;
  mask-image: url('../../../assets/icons/Home15.svg');
}
.NavigationButton__Icon_Shape {
  mask-image: url('../../../assets/icons/Shape15.svg');
}
.NavigationButton__Icon_Texture {
  mask-image: url('../../../assets/icons/Texture15.svg');
}
.NavigationButton__Icon_Save {
  width: 60%;
  height: 60%;
  mask-image: url('../../../assets/icons/Save15.svg');
}
</style>
